/**
 * WhatsApp NodeJS SDK.
 *
 * @author Great Detail Ltd <info@greatdetail.com>
 * @author Dom Webber <dom.webber@hotmail.com>
 * @see    https://greatdetail.com
 */

import WebhookError from "./index.js";

export default class InvalidHubSignatureWebhookError extends WebhookError {}
